import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVolumeUp,
  faVolumeOff,
  faPause,
  faPlay
} from "@fortawesome/free-solid-svg-icons";
import { isInteractiveKeyCode } from "../../utils/helpers";

class ChildVideo extends Component {
  constructor(props) {
    super(props);

    this.videoPlayer = null;
    this.setVideoRef = (element) => {
      this.videoPlayer = element;
    };
  
    this.state = {
      videoMute: true,
      videoPause: false,
    };
  }

  handlePlayKeyUp(e) {
    if(isInteractiveKeyCode(e)) {
      this.handleVideoPlay(e);
    }
  }

  handleAudioKeyUp(e) {
    if(isInteractiveKeyCode(e)) {
      this.handleAudio(e);
    }
  }

  UNSAFE_componentWillReceiveProps() {
    this.playVideo();
  }

  handleAudio(e) {
    e.preventDefault();
    this.setState(
      (prevState) => ({
        videoMute: !prevState.videoMute,
      }),
      () => (this.videoPlayer.muted = this.state.videoMute)
    );
  }

  handleVideoPlay(e) {
    e.preventDefault();
    this.setState(
      (prevState) => ({
        videoPause: !prevState.videoPause,
      }),
      () => {
        this.playVideo();
      }
    );
  }

  playVideo() {
    if (this.props.videoUrl != null) {
      this.state.videoPause === false ? this.videoPlayer.play() : this.videoPlayer.pause();
      this.videoPlayer.muted = this.state.videoMute;
    }
  }

  renderAudioIcons() {
    if (this.state.videoMute === true) {
      return <FontAwesomeIcon aria-hidden="true" icon={faVolumeOff} />;
    } else {
      return <FontAwesomeIcon aria-hidden="true" icon={faVolumeUp} />;
    }
  }

  renderPlayIcons() {
    if (this.state.videoPause === true) {
      return (
        <div className="video-play">
          <FontAwesomeIcon aria-hidden="true" icon={faPlay} />
          <span className="sr-only">Play</span>
        </div>
      );
    } else {
      return (
        <div className="video-pause">
          <FontAwesomeIcon aria-hidden="true" icon={faPause} />
          <span className="sr-only">Pause</span>
        </div>
      );
    }
  }

  renderLanguage() {
    if (this.props.showLanguage == true) {
      return <div className="video__child-language">{`${this.props.videoText} ${this.props.videoLanguage}`}</div>;
    } else {
      return false;
    }
  }

  render() {
    if (this.props.videoUrl != null) {
      return (
        <section className="child-video__container child-detail__item child-detail__item--video">
          <video playsInline muted={true} ref={this.setVideoRef} loop={(this.props.loop)?this.props.loop:undefined}>
            <source src={this.props.videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="video-controls">
            <button 
              className="video-toggle video-playing"
              onClick={(e) => this.handleVideoPlay(e)}
              onKeyUp={(e) => this.handlePlayKeyUp(e)}
            >
              {this.renderPlayIcons()}
            </button>
            <button
              className="audio-toggle audio-off audio-on-icon"
              id="audio-toggle"
              onClick={(e) => this.handleAudio(e)}
              onKeyUp={(e) => this.handleAudioKeyUp(e)}
            >
              {this.renderAudioIcons()}
              <span className="sr-only">Toggle video audio</span>
            </button>
          </div>
          {this.renderLanguage()}
        </section>
      );
    } else {
      return false;
    }
  }
}

export default ChildVideo;
